import React from 'react'
import PortfolioContainer from '../../../components/Portfolio/PortfolioContainer';
import SearchFilter from '../../../components/Portfolio/SearchFilter';
import { eligibleForLender, productName, productType } from '../../../constant/selectOptions';
import { useLocation, useNavigate } from 'react-router-dom';
import TableCoulmns, { BOMColumns, SBIColumns } from './TableCoulmns';
import { useState } from 'react';
import { Context } from '../../../config/store';
import Button from '../../../components/Common/Button';
import Pagination from '../../../components/Pagination';
import TableNoRecords from '../../../components/Common/Table/TableNoRecords';
import Table from '../../../components/Common/Table';
import LenderUgroService from '../../../services/lender';
import { useEffect } from 'react';
import { toast } from 'react-toastify';
import { downloadFile } from '../../../common/download';
import './style.css'
import Modal from '../../../components/Modal';
import MasterDataService from '../../../services/master-data';
import { objectsForEach } from '../../../common/objectToArray';
import { unSecuredIds } from '../../../constant/constants';

const DOA = () => {
  let searchData = JSON.parse(sessionStorage.getItem('searchData'));
  // const getParamsFromSessionStorage = (key, type = null) => {
  //   let searchDataResult = searchData ? searchData[key] : '';
  //   if (type === 'date' && searchDataResult) {
  //     let convertedDate = searchDataResult?.split('/')
  //     return new Date(`${convertedDate[1]}/${convertedDate[0]}/${convertedDate[2]}`)
  //   }
  //   return searchDataResult;
  // }

  const location = useLocation();
  const navigate = useNavigate()
  const [queryParams, setQueryParams] = React.useState("");
  const [tableData, setTableData] = useState({
    rows: [],
  });
  const [loading, setLoading] = React.useState(false);
  const [page, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(100);
  const [pagination, setPagination] = useState({});
  const { state, dispatch } = React.useContext(Context);
  const [sortParams, setSortParams] = React.useState({
    sortBy: "",
    sortOrder: "",
  });
  // let lenderId = getParamsFromSessionStorage('doaLender')
  const [excelLoader, setExcelLoader] = useState(false)
  const [tableHeaderChecked, setTableHeaderChecked] = useState(false);
  let [selectedIds, setSelectedIds] = React.useState({});
  const [selectedLender, setSelectedLender] = useState(0)
  const [modalState, setModalState] = useState(true)
  const [reloadLendersList, setReloadLendersList] = useState(false)
  const [dummySelectedLender, setDummySelectedLender] = useState(0);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);

  useEffect(() => {
    sessionStorage.setItem('searchData', JSON.stringify({ ...searchData, org_page: 1 }))
    if (selectedLender && queryParams){
      getDoaList(true)
    }
  }, [perPage, queryParams, selectedLender])

  useEffect(() => {
    sessionStorage.setItem('searchData', JSON.stringify({ ...searchData, org_page: page }))
    if (selectedLender && queryParams)
      getDoaList()
  }, [page])

  const getDoaList = async (paramsChanged, sortOrder, sortBy) => {
    try {
      setLoading(true);
      let response = await LenderUgroService.getDoaList({
        type: state.userType,
        page: paramsChanged ? 1 : page,
        per_page: perPage,
        // isOps,
        leadType: 'assigned',
        dataExport: 0,
        sortBy: sortBy ? sortBy : sortParams.sortBy,
        sortOrder: sortOrder ? sortOrder : sortParams.sortOrder,
        queryParams,
      });
      if (response?.data?.status?.code == 1) {
        const data = response.data.data?.cl_leads;
        setTableData({
          ...tableData,
          rows: data?.data || [],
        });
        let isHederchecked = headerCheckboxChecked(data?.data || []);
        setTableHeaderChecked(isHederchecked);
        setCurrentPage(page);
        setPagination(response?.data?.data.cl_leads.pagination);
        setLoading(false);
      }
    } catch (error) {
      toast.error("Something went wrong")
      setLoading(false);
    }
  };

  const exportLead = async (paramsChanged, sortOrder, sortBy) => {
    setExcelLoader(true)
    try {
      let response = await LenderUgroService.getDoaList({
        type: state.userType,
        page: paramsChanged ? 1 : page,
        // isOps,
        leadType: 'assigned',
        dataExport: 1,
        sortBy: sortBy ? sortBy : sortParams.sortBy,
        sortOrder: sortOrder ? sortOrder : sortParams.sortOrder,
        queryParams,
        responseType: "blob",
      });
      downloadFile(response.data, 'DoA' + +new Date());
      setExcelLoader(false)
    } catch (error) {
      toast.error("Something went wrong")
      setExcelLoader(false)
    }
  };

  const tableHeaderCheckboxUpdateCallback = (checked, data) => {
    setTableData({
      ...tableData,
      rows: data,
    });
    setTableHeaderChecked(checked);
    getSelectedIds();
  };

  const tableRowCheckboxUpdateCallback = (
    data,
    selectedLength,
    state,
    currentIndex
  ) => {
    setTableData({
      ...tableData,
      rows: data,
    });
    getSelectedIds(true, state, currentIndex);
  };

  const getSelectedIds = (singleRowCheck, state, currentIndex) => {
    let selectedItems = {};
    if (singleRowCheck) {
      if (!state) {
        delete selectedIds[tableData.rows[currentIndex].laf_id];
      } else {
        selectedIds[tableData.rows[currentIndex].laf_id] = tableData.rows[currentIndex].cl_lead_id;
      }
    } else {
      tableData.rows.forEach((data) => {
        if(data.checked)
          selectedItems[data.laf_id] = data.cl_lead_id;
        else
          delete selectedIds[data.laf_id];
      });
      selectedIds = {...selectedIds, ...selectedItems};
    }
    return setSelectedIds(selectedIds);
  };

  const showCheckbox = (row) => {
    // handling CGPAN for SBI and batch_id for BOM to hide/show checkbox inside first column
    return ((selectedLender == 1 && unSecuredIds.includes(row?.prod_type) && !row?.doa_additional_info?.doa_logs?.status) || (selectedLender == 23 && !row?.doa_additional_info)) ? false : true;
	};

  const checkDoaLogs = (row) => {
    // handling DoA Logs validation for SBI (CGPAN info icon inside the checkbox column)
    return (selectedLender == 1 && unSecuredIds.includes(row?.prod_type) && row?.doa_additional_info && !row?.doa_additional_info?.doa_logs?.status) ? true : false;
	};

  const handleFinalDoaSubmit = async () => {
    setLoading(true)
    let cl_lead_ids = Object.values(selectedIds);
    try {
      let response = await LenderUgroService.finalDoaSubmit(
      {
        "cl_lead_id": cl_lead_ids,
        "cl_lender_id": selectedLender
      });
      if (response?.data?.status?.code == 1) {
        let success = response?.data?.messages?.success;
        toast.success(success?.others?.[0]);
        Object.keys(selectedIds).forEach(key => delete selectedIds[key]);
        getDoaList()
      }
      setShowConfirmationModal(false)
      setLoading(false)
    } catch (err) {
      let error = err?.response?.data?.messages?.error;
      toast.error(error?.form?.[0] || error?.others?.[0]);
      setLoading(false);
    }
  }

  const headerCheckboxChecked = (tt)=>{
    if(!tt.length)
      return false;
		return tt.every(d => selectedIds?.[d.laf_id]);
	}

  const checkHasPermission = (checkPermission) => {
    if (state.is_super_admin === 1) return true;
    const permission = state.permission.find(
      (permission) => permission === checkPermission
    );

    if (permission) return true;
    else return false;
  };

  const toggleModal = () => {
    setModalState(!modalState)
  }

  const handleFormSubmit = () => {
    setModalState(false)
    setReloadLendersList(true)
  }

  return (
    <PortfolioContainer>
      <SearchFilter
        setQueryParams={setQueryParams}
        subType={state.userType}
        loading={loading}
        reloadLendersList={reloadLendersList}
        selectedDoaLender={selectedLender}
        setSelectedDoaLender={setSelectedLender}
        isDoa={true}
      ></SearchFilter>
      <div className="d-flex justify-content-end mr-3">
        <div className='row'>
          {/* <div className="d-flex justify-content-start">
        <div className='row ml-1'> */}
          <Button
            classNames='float-right text-orange mt-2'
            clickHandler={() => {
              sessionStorage.removeItem('searchData')
              navigate(state.selectedColender)
            }}
            type='btn-outline-custom'
          >
            <i className='fa fa-chevron-left mr-1'></i>Back
          </Button>
          {checkHasPermission('send-to-doa') && <Button
            type='btn-export'
            classNames='float-right text-white mt-2 ml-2'
            clickHandler={setShowConfirmationModal}
            disabled={Object.values(selectedIds)?.length < 1}
          >
            Submit
          </Button>}
        </div>

        {/* {excelLoader ? <Button classNames='excelDownloadLoader my-3'> <div className="loader"></div></Button> :
          <Button
            type='btn-export'
            classNames='float-right text-orange mt-2 '
            clickHandler={exportLead}
          >
            Export Excel
          </Button>
        } */}
      </div>
      <div>
        <div class='form-group'>
          <div class='row'>
            <div class='col-1'>
              <select
                class='form-control custom-form-control'
                onChange={(e) => {setPerPage(e.target.value); tableHeaderCheckboxUpdateCallback(false, [])}}
                value={perPage}
              >
                <option value={100}>{"100"}</option>
                <option value={200}>{"200"}</option>
                <option value={500}>{"500"}</option>
                <option value={1000}>{"All"}</option>
              </select>
            </div>
            <div class='col-2'>
              <span style={{'vertical-align': 'middle', 'margin-left': '-20px'}}>Entries per Page</span><br/>
              <span style={{'vertical-align': 'middle', 'color': '#f17640', 'font-weight': 700, 'margin-left': '-20px'}}>{`(${Object.values(selectedIds)?.length} LAF${Object.values(selectedIds)?.length>1 ? 's' : ''} Selected)`}</span>
            </div>
          </div>
        </div>
      </div>
      <div className="doa_table">
        <Table
          checkbox={true}
          columns={selectedLender == 23 ? BOMColumns : (selectedLender == 1 ? SBIColumns : TableCoulmns)}
          rows={tableData.rows}
          customCheck={showCheckbox}
          checkDoaLogs={checkDoaLogs}
          showHeaderCheckbox={true}
          headerChecked={tableHeaderChecked}
          headerCheckboxUpdateCallback={tableHeaderCheckboxUpdateCallback}
          rowCheckboxUpdateCallback={tableRowCheckboxUpdateCallback}
          loading={loading}
          reloadTable={getDoaList}
          hint={true}
          // onSortChange={onSortChange}
          // type='unassigned'
          tableName={'DOA'}
          selectedLender={selectedLender}
          selectedIds={selectedIds}
        >
          {Boolean(!tableData.rows.length && !loading) && <TableNoRecords />}
        </Table>
      </div>
      <div className="my-2">
        
        {(page && pagination?.total_pages) &&
          <Pagination
            disabled={loading}
            setPage={setCurrentPage}
            total_pages={pagination.total_pages}
            total={pagination.total}
            showTotal={true}
            perPage={pagination.per_page}
            key={perPage}
          />
        }
      </div>
      <Modal state={modalState} closeModal={toggleModal} style={{ width: "450px" }} removeBorderSpace={true} closeOnOverlayClick={false}>
        <div className="modal-header-container">
          <div className="modal-title">Send To DoA</div>
          {/* <div className="closeModalView" onClick={toggleModal}>
            <span className="closeModalIcon">x</span>
          </div> */}
        </div>
        <div className='p-4'>
          <form onSubmit={handleFormSubmit}>
            <div style={{ overflowY: "scroll", overflowX: 'clip', padding: "2%" }}>
              <div class='form-group'>
                <label>Assigned Lender<tt>*</tt></label>
                <div class='row'>
                  <div class='col-12'>
                    <select
                      class='form-control custom-form-control'
                      onChange={(e) => setDummySelectedLender(e.target.value)}
                      value={dummySelectedLender}
                    >
                      <option value={''}>Please Select</option>
                      <option value={1}>{"State Bank Of India"}</option>
                      <option value={3}>{"Central Bank Of India"}</option>
                      <option value={23}>{"Bank Of Maharashtra"}</option>
                      <option value={20}>{"Karnataka Bank"}</option>
                      <option value={2}>{"IDBI Bank"}</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
            <div class='d-flex align-items-center justify-content-center mt-3'>
              <button type='submit' class='btn btn-custom' disabled={loading || !dummySelectedLender} onClick={() => setSelectedLender(dummySelectedLender)}>
                {loading ? <div className='loader' /> : 'OK'}
              </button>
              <button
                type='button'
                class='btn btn-outline-custom ml-2'
                data-dismiss='modal'
                onClick={() => {
                  sessionStorage.removeItem('searchData')
                  navigate(state.selectedColender)
                  toggleModal()
                }}
              >
                Cancel
              </button>
            </div>
          </form>
        </div>
      </Modal>
      <Modal state={showConfirmationModal} style={{ width: "370px" }} removeBorderSpace={true} closeOnOverlayClick={false}>
          <div className="modal-header-container">
              {/* <div className="modal-title">Attention</div>
              <div className="closeModalView" onClick={()=>setShowConfirmationModal(false)}>
                  <span className="closeModalIcon">x</span>
              </div> */}
          </div>
          <div className="p-4">
              <div>
                  <div class='form-group'>
                      <label>{`${Object.values(selectedIds)?.length} LAF${Object.values(selectedIds)?.length>1 ? 's' : ''} selected, please confirm to ${selectedLender == 23 ?  'Generate CIF.' : 'proceed for DoA.'}`}</label>
                  </div>
                  <div class='d-flex align-items-center justify-content-center mt-3'>
                      {checkHasPermission('send-to-doa') &&
                      <button type='button' class='btn btn-custom' disabled={loading} onClick={handleFinalDoaSubmit}>
                          {loading ? <div className='loader' /> : 'OK'}
                      </button>}
                      <button
                          type='button'
                          class='btn btn-outline-custom ml-2'
                          data-dismiss='modal'
                          onClick={()=>setShowConfirmationModal(false)}
                      >
                          Cancel
                      </button>
                  </div>
              </div>
          </div>
      </Modal>
    </PortfolioContainer>
  )
}

export default DOA